export const aciSkiPassesAvailable = {
    iconName: 'ski-passes-available',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M19.576 12a2.58 2.58 0 012.58-2.58V6.195a1.29 1.29 0 00-1.29-1.29H4.095a1.29 1.29 0 00-1.29 1.29V9.42a2.58 2.58 0 010 5.16v3.225a1.29 1.29 0 001.29 1.29h16.77a1.29 1.29 0 001.29-1.29V14.58a2.58 2.58 0 01-2.58-2.58v0z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M10.768 8.575l1.712 1.142 1.713-1.142M12.48 16.567V7.433M10.768 15.425l1.712-1.142 1.713 1.142M15.905 10.288L14.764 12l1.141 1.713M7.914 12h9.133M9.056 10.288L10.197 12l-1.141 1.713',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
